import PropTypes from "prop-types"
import { OPTIONAL_CHART_ITEM } from "helpers/shapes"
import "./style.scss"

function Trend({ children, data }) {
  if (data && data.length >= 1) {
    return <div className="trend">
      {children}
    </div>
  } else {
    return null
  }
}

Trend.propTypes = {
  data: PropTypes.arrayOf(OPTIONAL_CHART_ITEM).isRequired,
  children: PropTypes.element.isRequired,
}

export default Trend
